import moment from 'moment';

export default [
  {
    name: 'barcode',
    label: 'Barcode',
    component: 'viewOnly'
  },
  {
    name: 'vehicleType',
    label: 'Vehicle Type *',
    component: 'select',
    options: [
      { id: 'Tractor', label: 'Tractor' },
      { id: 'Trailer', label: 'Trailer' }
    ]
  },
  { name: 'assetName', label: 'Asset Name', component: 'input' },
  { name: 'assetIdentificationNumber', label: 'Asset Identification Number', component: 'input' },
  { name: 'licensePlate', label: 'License Plate', component: 'input' },
  { name: 'vinNumber', label: 'Vin Number', component: 'input' }
];
